export default "__VITE_ASSET__D0n_TYsS__"